import { format, parseISO } from "date-fns";

export const formatUserName = (
  firstName?: string | null,
  lastName?: string | null,
): string => {
  const clean = (part?: string | null) => {
    const value = (part ?? "").trim();
    return value.toLowerCase() === "null" ? "" : value;
  };
  return [clean(firstName), clean(lastName)].filter(Boolean).join(" ");
};

export const sanitizeUrl = (url: string): string => {
  try {
    return decodeURIComponent(url);
  } catch {
    return url;
  }
};

export const formatDisplayDate = (dateStr: string) => {
  if (!dateStr) return null;
  return new Date(dateStr).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const formatDisplayTime = (timeStr: string) => {
  if (!timeStr) return null;
  if (/^\d{2}:\d{2}$/.test(timeStr)) {
    const [hours, minutes] = timeStr.split(":");
    const date = new Date();
    date.setHours(parseInt(hours), parseInt(minutes));
    return format(date, "h:mm a");
  }
  const date = new Date(timeStr);
  return isNaN(date.getTime()) ? null : format(date, "h:mm a");
};

export const toHHmm = (timeStr?: string): string | undefined => {
  if (!timeStr) return undefined;
  if (/^\d{2}:\d{2}$/.test(timeStr)) return timeStr;
  try {
    return format(parseISO(timeStr), "HH:mm");
  } catch {
    return undefined;
  }
};

export const capitalize = (value?: string | null): string => {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};
